import React from 'react';

export const ChatLoadingIndicator: React.FC = () => {
  return (
    <div className="mb-8 grid grid-cols-[30px_minmax(0,1fr)] gap-2 app-sm:grid-cols-[36px_minmax(0,1fr)] app-sm:gap-3">
      <span className="h-[30px] w-[30px] rounded-ds-8 border border-ds-100 bg-ds-white app-sm:h-9 app-sm:w-9" />
      <div className="flex items-center gap-3 text-xs text-ds-600">
          <div className="flex gap-1.5" aria-hidden="true">
            <div className="h-1.5 w-1.5 animate-bounce rounded-full bg-ds-primary" style={{ animationDelay: '0ms' }} />
            <div className="h-1.5 w-1.5 animate-bounce rounded-full bg-ds-primary" style={{ animationDelay: '150ms' }} />
            <div className="h-1.5 w-1.5 animate-bounce rounded-full bg-ds-primary" style={{ animationDelay: '300ms' }} />
          </div>
          <span>دستیار داره اطلاعات رو جست‌وجو و پردازش می‌کنه...</span>
      </div>
    </div>
  );
};
